module.exports = __webpack_public_path__ + "static/media/valor1_2_1.201885dd.png";